const dataText = JSON.stringify([
    {
        group:'日k',
        data:[
            {name:"10-08",value: [20, 34, 10, 38]},
            {name:"10-09",value: [40, 35, 30, 50]},
            {name:"10-10",value: [30, 45, 20, 50]},
            {name:"10-11",value: [10, 25, 5, 30]},
            {name:"10-12",value: [35, 22, 10, 20]},
            {name:"10-13",value: [20, 34, 10, 38]},
        ]
    }
])

export default {
    attribute:{
        color:['#009900','#ff00ff','#df9e08','#4677ff'],
        title: {
            text: '日K',
            left: 'center',
            top: 'top',
            textStyle:{
                fontSize:18,
                color: '#ccc'
            },
            subtextStyle: { fontSize: 12, color: '#aaa' }
        },
        xAxis: {
            show: true,
            name: '',
            axisLabel:{
                show: true,
                color: '#6aa9e4',
                fontSize:13,
                rotate:0//倾斜角度-180~180
            },
            axisLine:{
                show: true,
                lineStyle: {
                    color: '#02438e'
                }
            },
            axisTick:{//x轴刻度线
                show: false
            },
            splitLine: {//网格线
                show: false
            }
        },
        yAxis: {
            show: true,
            name: '',
            type: 'value',
            axisLabel:{
                show: true,
                color: '#6aa9e4',
                fontSize: 13
            },
            axisLine:{
                show: false,
                lineStyle:{
                    color: '#14477e'
                }
            },
            axisTick:{//y轴刻度线
                show: false
            },
            splitLine: {//网格线
                show: true,
                lineStyle:{
                    color: ['#14477e', '#14477e']
                }
            }
        },
        legend: {
            show: true,
            left: 'center',
            top: 'bottom',
            orient: 'horizontal',
            textStyle: {
                color:'#6aa9e4',
                fontSize:14
            }
        },
        grid:{
            x:10,y:30,x2:10,y2:30,
        },
        tooltip: {
            trigger: 'axis',
            backgroundColor: 'rgba(0,0,0,0.5)',
            textStyle: {
                color: "#fff",
            },
            axisPointer: {            // 坐标轴指示器，坐标轴触发有效
                type: 'shadow',       // 默认为直线，可选为：'line' | 'shadow'
            }
        },
        dataZoom: {show: false,height:15},
        cptTableData: [{ "name": "分组", "value": "", "namekey": "group" },
        { "name": "维度", "value": "", "namekey": "name" },
        { "name": "指标", "value": "", "namekey": "value" }]
    },
    cptDataForm:{
        dataText:dataText, dataSource: 1, pollTime: 0
    },
}
